import fetchAPI from './fetchAPI';

const getMatchingUsers = (v, currentValues = null) =>
  fetchAPI(
    `/users/v1/eu/search?offset=0&limit=100&sort='status' asc&query=[
      [
        {"field": "'info'->'email'", "op": "ILIKE", "value": "%${v}%", "internOp": "OR"},
        {"field": "'info'->'lastName'", "op": "ILIKE", "value": "%${v}%", "internOp": "OR"},
        {"field": "'info'->'userName'", "op": "ILIKE", "value": "%${v}%", "internOp": "OR"},
        {"field": "'info'->'firstName'", "op": "ILIKE", "value": "%${v}%", "internOp": "OR"}
    ]
  ]`.replace(/\n\s+/g, '    ')
  ).then(({ results }) => {
    let assignedUserEmail, mapResults, fullResults;
    assignedUserEmail =
      currentValues && currentValues.info ? currentValues.info.email : '';
    mapResults = results
      .filter(u => u.info.email !== assignedUserEmail)
      .map(u => {
        return {
          text: u.info.firstName + ' ' + u.info.lastName,
          value: {
            label: null,
            value: u.id,
            data: {
              firstName: u.info.firstName,
              lastName: u.info.lastName,
              email: u.info.email
            }
          }
        };
      });
    fullResults = [];
    if (currentValues) {
      fullResults = [
        {
          text:
            currentValues.info.firstName +
            ' ' +
            currentValues.info.lastName,
          value: {
            label: null,
            value: currentValues.submitterId,

            data: {
              firstName: currentValues.info.firstName,
              lastName: currentValues.info.lastName,
              email: currentValues.info.email,
              current: true
            }
          }
        }
      ];
    }
    fullResults = [...fullResults, ...mapResults];
    return fullResults;
  });

export default getMatchingUsers;